/* eslint-disable import/prefer-default-export */
export const RECEIVE_AUTO_SUGGESTIONS = 'RECEIVE_AUTO_SUGGESTIONS';
